import rplumbodata from "./raw/rplumbo.json";
import rplumboDataInterval from "./raw/rplumbo_in.json";

export const rPlumboColorMap = (type) => {
  if (type === "range") {
    return rplumbodata;
  }

  if (type === "interval") {
    return rplumboDataInterval;
  }
};
